import React, { useEffect, useContext, useState } from 'react';
import WebLogo from "../Image/zupprfooter.png";
import { Link, useNavigate } from 'react-router-dom';
import PlaystoreLogo from "../Image/PlayStore.png";
import AppStoreLogo from "../Image/AppStore.png";
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
const Footer = () => {

  const { BaseUrl } = useContext(MyContext);

  const [pagelist, setPageList] = useState([]);

  const navigate = useNavigate();

  const currentYear = new Date().getFullYear();

  const HandleOpenLink = (Link) => {
    window.open(Link, "blank");
  }

  useEffect(() => {
    axios.get(`${BaseUrl}/eapi/e_pagelist.php`)
      .then((res) => {
        // console.log("e_pagelist.php", res.data);
        setPageList(res.data.pagelist);
      })
      .catch((error) => {
        console.error("e_pagelist.php", error);
      })
  }, []);

  const HandleNavigate = (path) => {
    navigate(`/pages/${path}`);
  };

  return (
    <div className="footer_page">
      <div className="width_container">
        <div className="pt-[50px] pb-[80px] flex flex-wrap items-start justify-between gap-[20px]">

          <div className="w-[30%] max-_580_:w-full">
            <Link to="/" className="flex items-center max-_430_:justify-center gap-[10px]">
              <img src={WebLogo} className="w-[100px]" alt="WebLogo" />
            </Link>
            <p className="font-[500] text-gray-700 max-_430_:text-center">© {currentYear} Zuppr Limited</p>
          </div>

          <div className="w-[60%] max-_580_:w-full flex items-center justify-end max-_430_:justify-center gap-[20px]">

            <div className="w-[30%] max-_580_:w-[40%]">
              <h1 className="font-bold text-[18px] text-gray-600">Other Pages</h1>
              {pagelist.map((item, index) => {
                const Title = item.title.replace(/\s+/g, '-');
                const FinalText = Title.toLowerCase();
                return <p onClick={() => HandleNavigate(`${FinalText}`)} key={index} className="cursor-pointer text-[15px] py-[3px] text-gray-600 hover:text-black">{item.title}</p>
              })}
              <Link to="/faq" className="cursor-pointer text-[15px] py-[3px] text-gray-600 hover:text-black">Faq's</Link>
            </div>

            <div className="w-[30%] max-_580_:w-[40%] flex justify-end">
              <div className="">
                <button onClick={() => HandleOpenLink("https://play.google.com/")}>
                  <img src={PlaystoreLogo} className="w-[150px]" alt="PlaystoreLogo" />
                </button>
                <button onClick={() => HandleOpenLink("https://apps.apple.com/")}>
                  <img src={AppStoreLogo} className="w-[150px] mt-[10px]" alt="AppStoreLogo" />
                </button>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default Footer